// The six solution categories. This order matches the Solutions page and the contact
// form's solution list (`contact.form.services`), which is looked up by index.
export const SOLUTION_KEYS = ["web", "ecommerce", "backend", "erp", "ai", "more"];

// Opens the Solutions page with a category expanded.
export const solutionPath = (key) => `/services?category=${key}`;
